import { render, staticRenderFns } from "./DeliveryCard.vue?vue&type=template&id=7ee0360b&scoped=true"
import script from "./DeliveryCard.vue?vue&type=script&lang=js"
export * from "./DeliveryCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCard.vue?vue&type=style&index=0&id=7ee0360b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee0360b",
  null
  
)

export default component.exports